export default {
  cfg: {
    serviceUrl:
      'https://tjj5z31z7h.execute-api.eu-central-1.amazonaws.com/prod/addFeedback',
    conferenceId: 'biznisnet2020',
  },
  definitions: {
    presentation: require('./presentation').default,
    reportProblem: require('./reportProblem').default,
  },
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/addons/feedback/index.js